import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import BakirkoyIntro from "../components/ServiceRegions/İntros/BakirkoyIntro";
import DynamicImage from "../components/DynamicImage";


const BakirkoyPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      <DynamicImage />
      {/* <AboutSection/> */}
      <BakirkoyIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};
export default BakirkoyPage;